<template>
  <v-menu 
    top
    offset-y
    content-class="qmkey-explorer-table-menu-contents"
  >
    <template v-slot:activator="{ attrs, on }">
        <v-icon
          small
          icon
          class="mr-2"
          v-on="on"
          v-bind="attrs"
          @click.stop="click(site)"
        >
          mdi-home-import-outline
        </v-icon>
    </template>
    <v-list dense>
      <v-list-item
        v-for="action in actions"
        :key="action.id"
        @click.stop="action_transition(action, site)"            
      >
        <v-list-item-icon>
          <v-icon
            v-text="action.icon"
            small
          >
          </v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ action.label }}</v-list-item-title>        
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>

import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import ViewTitle from '@/components/ViewTitle'
import EmpresaImportExport from '@/api/EmpresaImportExport'
import ModalDialogForm from '@/components/explorer/ModalDialog'
import { downloadFile } from '@/utils/browserfiles';
import { InfoAlert, SuccessAlert, ErrorAlert } from '@/utils/Alerts'

export default {
  name: 'ImportSiteActions',
  components: {
    ViewTitle,
    ModalDialogForm,
  },
  props: {
    site: {
      type: Object,
      required: true
    },
  },

  data: () => ({
    actions: [
      {
        "id": "import-pakage",
        "label": "Import from pakage",
        "icon": "mdi-package-up",
      },
      {
        "id": "import-excel",
        "label": "Import from excel",
        "icon": "mdi-file-excel",
      },
      // {
      //   "id": "advanced-export-excel",
      //   "label": "Advanced Export to excel",
      //   "icon": "mdi-arrange-send-backward",
      // },
    ]
  }),
  computed: {
  },

  methods: {
    action_transition(action, item) {
      console.log(action);
      console.log(item);
      this.$emit(action.id, item);
      // if (action.id == 'export-package') {
      //   // this.exportSite(item);
      //   this.$emit('export-package', item);
      // }
      // else if (action.id == 'export-excel') {
      //   // this.export_excel(item);
      //   this.$emit('export-excel', item);
      // }
      // else if (action.id == 'advanced-export-excel') {
      //   // this.export_excel(item);
      //   this.$emit('advanced-export-excel', item);
      // }
    },

    toggle_dialog() {
      this.showModalDialog = false;
      this.modalTitle = ``;
      this.fields_to_collect = [];
      this.submit_action = (()=>{});
      this.submit_button_caption = '';
    },
    click(site) {
      this.$emit('clicked');
      console.log('click', site);
      const data = EmpresaImportExport.getAvailableSheets(site.path);
      console.log(data);
    },
  },

  mounted() {
    // this.getAvailableSheets();
  },

}
</script>


<style lang="scss">
@import "@/sass/menus.scss";
@import "@/sass/explorer.scss";
</style>